import { render, staticRenderFns } from "./ReportActionMenu.vue?vue&type=template&id=08bb4260&scoped=true"
import script from "./ReportActionMenu.vue?vue&type=script&lang=ts"
export * from "./ReportActionMenu.vue?vue&type=script&lang=ts"
import style0 from "./ReportActionMenu.vue?vue&type=style&index=0&id=08bb4260&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08bb4260",
  null
  
)

export default component.exports